import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataProductOnboardingFormsState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataProductOnboardingFormsReducer.productOnboardingFormsFeatureKey]
);

export const getStaticDataProductOnboardingFormsFailure = createSelector(
  getStaticDataProductOnboardingFormsState,
  staticDataCountriesReducer.fromStaticDataProductOnboardingFormsReducer.getProductOnboardingFormsFailure
);

export const getStaticDataProductOnboardingFormsResponse = createSelector(
  getStaticDataProductOnboardingFormsState,
  staticDataCountriesReducer.fromStaticDataProductOnboardingFormsReducer.getProductOnboardingFormsResponse
);

export const getStaticDataProductOnboardingFormsisLoaded = createSelector(
  getStaticDataProductOnboardingFormsState,
  staticDataCountriesReducer.fromStaticDataProductOnboardingFormsReducer.getProductOnboardingFormsIsLoaded
);
